interface SectionIntroProps {
  eyebrow: string;
  title: string;
  desc?: string;
  center?: boolean;
  action?: { label: string; href: string; icon?: string };
}

export default function SectionIntro({ eyebrow, title, desc, center, action }: SectionIntroProps) {
  return (
    <div className={`flex flex-col gap-3 ${center ? "items-center text-center" : "sm:flex-row sm:items-end sm:justify-between"}`}>
      <div className={center ? "mx-auto max-w-2xl" : "max-w-2xl"}>
        <p className="flex items-center gap-2 text-xs font-semibold tracking-widest text-primary-600">
          <span className="inline-block h-px w-6 bg-primary-500"></span>
          {eyebrow}
        </p>
        <h2 className="mt-2 font-display text-2xl font-bold text-foreground-950 md:text-3xl">
          {title}
        </h2>
        {desc && <p className="mt-2 text-sm leading-relaxed text-foreground-600">{desc}</p>}
      </div>
      {action && (
        <a
          href={action.href}
          className="flex h-10 shrink-0 items-center gap-1 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
        >
          {action.icon && <i className={action.icon}></i>}
          {action.label}
        </a>
      )}
    </div>
  );
}